import jsPDF from 'jspdf';
import 'jspdf-autotable';
import HTTPRequest from '../../../controllers/httpRequest';
import secureStorage from '../../../controllers/secureStorage.js';
import moment from 'moment';
import { mapState } from 'vuex';

var printReltrx = {
    computed: {
        ...mapState(['profileId']),
    },
    methods: {
        async printRELTRX(isDefaultPrint, customFont) {
            this.spinning = true;

            let tabulatorInstance = this.$refs.tabulator.getInstance();
            let tableData = tabulatorInstance.getData();
            let documentDetails = this.documentDetails;

            console.log(`Printing RELTRX with isDefaultPrint=${isDefaultPrint} and customFont=${customFont} and this ${this}`, this);
            //console.log(this.documentDetails, this);

            const doc = new jsPDF('p', 'pt', 'a4');
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();
            let documentDate = moment(documentDetails.document_date, 'YYYY-MM-DD');
            if(documentDetails.wms_status == "300" || documentDetails.wms_status == 300 ){
                documentDate = moment(documentDetails.reference_6, 'YYYY-MM-DD');
            }
            let xLeftKey = 35;
            let xRightKey = 560;
            let requestingSiteId = this.documentDetails.target_site_id.key;
            let supplyingSiteId = this.documentDetails.site_id.key;

            let siteData = await HTTPRequest.getRequest(`${this.endPoint}sites/${supplyingSiteId}`, null, null);
            let companyData = await HTTPRequest.getRequest(`${this.endPoint}companies/${siteData.company_id}`, null, null);
            //let customer = await HTTPRequest.getRequest(`${this.endPoint}customers/${this.customer.key}`, null, null);
            //let b2b = await HTTPRequest.getRequest(`${this.endPoint}b2b_customers/${this.b2bCustomer}`, null, null);

            // let street_or_province = customer.street || b2b.province_name || "";
            // let barangay = customer.barangay_name || b2b.barangay_name || "";
            // let city = customer.city_name || b2b.city_name || "";

            // let formattedCustomerAddress = `${street_or_province}, ${barangay}, ${city}`;

            function addHeader(doc, companyData, documentDetails, xLeftKey, xRightKey, pageWidth, pageNumber, pageCount) {
                doc.setFontSize(12);
                doc.setFontStyle("bold");
                doc.text(`${companyData.name}`, xLeftKey, 30);

                // left content
                doc.setFontSize(8);
                doc.setFontStyle("normal");
                let companyAddress = doc.splitTextToSize(`${companyData.address || ''}`, 250);
                doc.text(companyAddress, xLeftKey, 40);
                doc.text(`VAT REG TIN: ${companyData.tin || ''}`, xLeftKey, 60);
                doc.text(`TEL. NO.: ${companyData.telephone || ''}`, xLeftKey, 70);
                doc.text(`FAX NO.: ${companyData.fax || ''}`, xLeftKey, 80);

                // right Content
                doc.setFontSize(8);
                doc.setFontStyle("normal");
                // doc.text(`Page ${pageNumber}/${pageCount}`, xRightKey, 30, { align: 'right' });
                doc.setFontSize(10);
                doc.setFontStyle("bold");
                doc.text('STOCK TRANSFER OUT', xRightKey, 40, { align: 'right' });
                doc.setFontSize(8);
                doc.setFontStyle("normal");
                doc.text(`${handleNull(documentDetails.cas_no)}`, xRightKey, 50, { align: 'right' });
                doc.text('ORIGINAL COPY', xRightKey, 60 , { align: 'right' });
            }

            // generate the first serial number from the prefix
            function generateFirstSerialNumber(casNo) {
                // split the cas_no to extract the prefix and current serial number
                const parts = casNo.split("-");
                const prefix = parts.slice(0, -1).join("-");
                const firstSerialNumber = `${prefix}-00000001`;
                return firstSerialNumber;
            }

            const currentSerialNumber = handleNull(documentDetails.cas_no);
            const firstSerialNumber = generateFirstSerialNumber(currentSerialNumber);

            function addFooter(doc, pageWidth, pageHeight) {
                const currentDate = moment().format('MM/DD/YYYY');
                const currentTime = moment().format('HH:mm');
                var userName = secureStorage.getItem("userName");

                doc.setFontSize(8);
                doc.setFontStyle("normal");
                doc.text(`CAS Permit Number: ${companyData.cas_permit_number}`, 40, pageHeight - 60);
                doc.text(`Date Issued: ${moment().format('MM/DD/YYYY')}`, 40, pageHeight - 50);
                //doc.text(`Serial Number Range: ${firstSerialNumber} - ${currentSerialNumber}`, 40, pageHeight - 20);
                doc.text(`Serial Number Range: ${'STO' + '-' + documentDetails.company_code + '-' +  companyData.series_number_range.split('-')[0] + ' - ' + 'STO' + '-' + documentDetails.company_code + '-' +  companyData.series_number_range.split('-')[1]}`, 40, pageHeight - 40);
                doc.text(`${documentDetails.status}`, pageWidth - 40, pageHeight - 60, { align: 'right' });
                doc.text(`${userName}`, pageWidth - 40, pageHeight - 50, { align: 'right' });
                doc.text(`${currentDate} ${currentTime}`, pageWidth - 40, pageHeight - 40, { align: 'right' });
            }

            function handleNull(value) {
                return value == null || value == "Invalid date" ? '' : value;
            }

            addHeader(doc, companyData, documentDetails, xLeftKey, xRightKey, pageWidth, 1, 1);

            // company info left
            const leftInfoTitleX = 35;
            const leftInfoContentX = 115;
            const leftInfoTextWidth = 150;
            const lineSpacingLeftSide = 27;
            let siteAddress = handleNull(siteData.address) || "No Site Address";

            let targetSiteLength = doc.getTextWidth(documentDetails.target_site_id.label)
            let sourceSiteLength = doc.getTextWidth(documentDetails.source_site_id.label)
            let addSiteLineSpace = sourceSiteLength > leftInfoTextWidth ? 10 : sourceSiteLength > (leftInfoTextWidth + 110) ? 20 : 0
            let addSiteLineSpace2 = targetSiteLength > leftInfoTextWidth ? 10 : targetSiteLength > (leftInfoTextWidth + 110) ? 20 : 0
            let addLineSpace = addSiteLineSpace + addSiteLineSpace2
            let addressLength = doc.getTextWidth(siteAddress)
            let addLineSpace2 = addressLength > (leftInfoTextWidth + 110) ? addLineSpace + 10 : targetSiteLength > leftInfoTextWidth ? 10 : 0
            
            doc.setFontSize(8);
            doc.setFontStyle("bold");
            doc.text('Brand:', leftInfoTitleX, 100);
            doc.text('Supplying Branch:', leftInfoTitleX, 110);
            doc.text('Requesting Branch:', leftInfoTitleX, 120 + addSiteLineSpace);
            doc.text('Site Type:', leftInfoTitleX, 130 + addLineSpace);
            doc.text('Address:', leftInfoTitleX, 140 + addLineSpace);
            doc.text('Purpose:', leftInfoTitleX, (80 + (3 * lineSpacingLeftSide)) + addLineSpace2);
            doc.text('Remark:', leftInfoTitleX, (90 + (3 * lineSpacingLeftSide))+ addLineSpace2);
         
            doc.setFontStyle("normal");
            // let customerName = handleNull(customer.name) || handleNull(b2b.name) || "No Customer Name";
            // let customerAddress = handleNull(formattedCustomerAddress) || "No Customer Address";
            // let deliveredTo = doc.splitTextToSize(customerName, leftInfoTextWidth);
            let siteName = handleNull(siteData.name) || handleNull(siteData.name) || "No Site Name";
            doc.text(doc.splitTextToSize(documentDetails.brand_names, leftInfoTextWidth), leftInfoContentX, 100);
            doc.text(doc.splitTextToSize(documentDetails.source_site_id.label, leftInfoTextWidth), leftInfoContentX, 110);
            doc.text(doc.splitTextToSize(documentDetails.target_site_id.label, leftInfoTextWidth), leftInfoContentX, 120 + addSiteLineSpace);
            doc.text(doc.splitTextToSize(siteData.channel_type_name, leftInfoTextWidth), leftInfoContentX, 130 + addLineSpace);
            let address = doc.splitTextToSize(siteAddress, leftInfoTextWidth);
            
            doc.text(address, leftInfoContentX, 140 + addLineSpace);
            doc.text(handleNull(documentDetails.purpose_id.label), leftInfoContentX, (80 + (3 * lineSpacingLeftSide)) + addLineSpace2);
            doc.text(handleNull(documentDetails.remark), leftInfoContentX, (90 + (3 * lineSpacingLeftSide)) + addLineSpace2);

            // company info right
            const rightInfoX = 350;
            const rightInfoContentX = rightInfoX + 93;
            const lineSpacingRightSide = 10;
            const splitTextToLines = (text, maxChars) => {
                const str = String(text);
                const lines = [];
                let currentLine = '';
            
                for (const char of str) {
                    if (currentLine.length + 1 > maxChars) {
                        lines.push(currentLine);
                        currentLine = char;
                    } else {
                        currentLine += char;
                    }
                }
                if (currentLine) {
                    lines.push(currentLine);
                }
                return lines;
            };
            
            let splitRef = splitTextToLines(documentDetails.reference || '', 31)
            let adjustYPosition = String(documentDetails.reference).length > 31 ? 12 : 0

            doc.setFontStyle("bold");
            doc.text('STO Date:', rightInfoX, 100);
            doc.text('Target Date:', rightInfoX, 100 + lineSpacingRightSide);
            doc.text('Cancellation  Date:', rightInfoX, 100 + 2 * lineSpacingRightSide);
            doc.text('Reference:', rightInfoX, 100 + 3 * lineSpacingRightSide);
            doc.text('Currency:', rightInfoX, (100 + 4 * lineSpacingRightSide) + adjustYPosition);
            doc.text('Currency Rate:', rightInfoX, (100 + 5 * lineSpacingRightSide) + adjustYPosition);
            doc.text('Status:', rightInfoX, (100 + 6 * lineSpacingRightSide) + adjustYPosition);
            doc.text('Delivery Date: ', rightInfoX, (100 + 7 * lineSpacingRightSide) + adjustYPosition);


            doc.setFontStyle("normal");
            
            doc.text(handleNull(documentDate.format('MM/DD/YYYY')), rightInfoContentX, 100);
            doc.text(handleNull(moment(documentDetails.target_date, 'YYYY-MM-DD').format('MM/DD/YYYY')), rightInfoContentX, 100 + lineSpacingRightSide);
            doc.text(handleNull(moment(documentDetails.cancellation_date, 'YYYY-MM-DD').format('MM/DD/YYYY')), rightInfoContentX, 100 + 2 * lineSpacingRightSide);
            doc.text(splitRef, rightInfoContentX, 100 + 3 * lineSpacingRightSide);
            doc.text(handleNull(documentDetails.currency_id.label), rightInfoContentX, (100 + 4 * lineSpacingRightSide) + adjustYPosition);
            doc.text(handleNull(documentDetails.currency_rate || '1'), rightInfoContentX, (100 + 5 * lineSpacingRightSide) + adjustYPosition);
            doc.text(handleNull(documentDetails.status), rightInfoContentX, (100 + 6 * lineSpacingRightSide) + adjustYPosition);
            doc.text(handleNull(moment(documentDetails.target_date, 'YYYY-MM-DD').format('MM/DD/YYYY')), rightInfoContentX, (100 + 7 * lineSpacingRightSide) + adjustYPosition);
            // table data
            const tableColumn = [
                { header: 'Item No.', dataKey: 'barcode', styles: { halign: 'right' } },
                { header: 'Quantity', dataKey: 'quantity', styles: { halign: 'right' } },
                { header: 'Unit', dataKey: 'unit_name', styles: { halign: 'left' } },
                { header: 'Particulars', dataKey: 'product_name', styles: { halign: 'left' } },
                { header: 'Unit Price', dataKey: 'price', styles: { halign: 'right' } },
                { header: 'Total Price', dataKey: 'subtotal', styles: { halign: 'right' } },
            ];

            function extractValues(data, keys) {
                return data.map(row => {
                    const newRow = {};
                    keys.forEach(column => {
                        if (row.hasOwnProperty(column.dataKey)) {
                            if (column.dataKey === 'price') {
                                // format amount of money w/ commas and w/ 2 decimal places
                                newRow[column.dataKey] = parseFloat(row[column.dataKey]).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                });
                            } else if (column.dataKey === 'subtotal') {
                                // format amount of money w/ commas and w/ 2 decimal places
                                newRow[column.dataKey] = parseFloat(row[column.dataKey]).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                });
                            } else if (column.dataKey === 'quantity') {
                                // format quantity as a whole number
                                newRow[column.dataKey] = Math.round(parseFloat(row[column.dataKey]));
                            } else {
                                newRow[column.dataKey] = row[column.dataKey];
                            }
                        }
                    });
                    return newRow;
                });
            }

            const extractedData = extractValues(tableData, tableColumn);

            // calculate totals
            let totalQuantity = 0;
            let totalPrice = 0;
            let formattedTotalPrice = 0;
            extractedData.forEach(row => {
                totalQuantity += parseFloat(row.quantity);
                totalPrice += parseFloat(row.subtotal);
                if (typeof row.subtotal === 'string') {
                    // remove commas before summing the values
                    formattedTotalPrice += parseFloat(row.subtotal.replace(/,/g, ''));
                } else {
                    formattedTotalPrice += parseFloat(row.subtotal);
                }
            });

            const formattedTotalPriceString = formattedTotalPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

            // add a separator row
            const separatorRow = [
                { content: '', colSpan: 1 },
                { content: '_________', colSpan: 1, styles: { halign: 'right' } },
                { content: '', colSpan: 2 },
                { content: '', colSpan: 1 },
                { content: '____________', colSpan: 1, styles: { halign: 'right' } },
            ];

            // footer row
            const footerRow = [
                { content: 'Total Quantity', colSpan: 1, styles: { halign: 'right' } },
                { content: totalQuantity.toLocaleString(), colSpan: 1, styles: { halign: 'right' } },
                { content: '', colSpan: 2 },
                { content: 'Total PHP', colSpan: 1, styles: { halign: 'right' } },
                { content: formattedTotalPriceString, colSpan: 1, styles: { halign: 'right' } },
            ];

            // "---Nothing Follows---" row
            const nothingFollowsRow = [
                { content: '---Nothing Follows---', colSpan: 6, styles: { halign: 'center', fontStyle: 'normal' } },
                { content: '', colSpan: 6 }
            ];

            // not a fixed table, item lists are dynamic
            const baseTableOptions = {
                theme: 'plain',
                startY: 200,
                styles: { fontSize: 8, cellPadding: 2.5 },
                margin: { left: 30, right: 30 },
                headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: 'center' },
                bodyStyles: { halign: 'center' },
                columnStyles: {
                    barcode: { cellWidth: 50 },
                    quantity: { cellWidth: 50 },
                    unit_name: { cellWidth: 50 },
                    product_name: { cellWidth: 190, halign: 'left' },
                    price: { cellWidth: 65 },
                    subtotal: { cellWidth: 65 },
                },
                didDrawPage: function (data) {
                    if (data.pageNumber > 1) {
                        addHeader(doc, companyData, documentDetails, xLeftKey, xRightKey, pageWidth, data.pageNumber, data.pageCount);
                    }
                    addFooter(doc, pageWidth, pageHeight);
                },
                head: [tableColumn.map(column => column.header)],
                body: extractedData.map(row => {
                    return tableColumn.map(column => {
                        return {
                            content: row[column.dataKey],
                            styles: { halign: column.styles.halign } // include the alignment style for each cell
                        };
                    });
                }),
                // table styles/line formatting
                // didParseCell: function (data) {
                //     // custom formatting if needed
                // },
                // willDrawCell: function (data) {
                //     if (data.section === 'body') {
                //         data.cell.styles.lineColor = [0, 0, 0];
                //         data.cell.styles.lineWidth = 1;
                //     }
                // },
                tableLineColor: [0, 0, 0],
                tableLineWidth: 1,
                showFoot: 'lastPage',
                // foot: [footerRow, nothingFollowsRow],
                footStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: 'center' },
            };

            // calculate table height and rows to move
            const footerHeight = 30;
            const maxRowsPerPage = Math.floor((580 - footerHeight) / 15);

            // function to render the table dynamically
            function renderTableParts(doc, data, options) {
                let currentIndex = 0;
                const totalRows = data.length;

                while (currentIndex < totalRows) {
                    const remainingRows = totalRows - currentIndex;
                    const rowsToRender = Math.min(remainingRows, (currentIndex === 0 ? maxRowsPerPage : maxRowsPerPage + 8));

                    // extract the current part of the data to render
                    const currentPart = data.slice(currentIndex, currentIndex + rowsToRender);

                    // update table options for the current part
                    options.body = currentPart.map(row => tableColumn.map(column => ({
                        content: row[column.dataKey],
                        styles: { halign: column.styles.halign }
                    })));

                    // check if this is the last part to render
                    if (currentIndex + rowsToRender >= totalRows) {
                        options.foot = [separatorRow, footerRow, nothingFollowsRow];
                        options.showFoot = 'lastPage';
                        options.footStyles = { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: 'center' };
                    } else {
                        options.foot = [];
                    }

                    // render the current part
                    doc.autoTable(options);

                    // move to the next part
                    currentIndex += rowsToRender;

                    // add a new page if there are more rows to render
                    if (currentIndex < totalRows) {
                        doc.addPage();
                        addHeader(doc, companyData, documentDetails, xLeftKey, xRightKey, pageWidth, doc.internal.getNumberOfPages(), doc.internal.getNumberOfPages());
                        options.startY = 100;
                    }
                }
            }

            // render the table dynamically
            renderTableParts(doc, extractedData, baseTableOptions);

            let finalY = doc.lastAutoTable.finalY + 30;

            if (finalY + 250 > pageHeight) {
                doc.addPage();
                finalY = 70;
                addFooter(doc, pageWidth, pageHeight);
                addHeader(doc, companyData, documentDetails, xLeftKey, xRightKey, pageWidth, 1, 1);
            }

            for(var i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.text('PAGE ' + i + '/' + pageCount, xRightKey, 30, { align: 'right' });
            }

            // conditions content formatting
            finalY += 40;
            doc.setFontSize(8);
            doc.text('CONDITIONS:', 40, finalY);
            doc.text('Customer acknowledges receipt of the above items in good order and condition.', 40, finalY + 15);
            doc.text('All items described herein shall remain to be property of this Company until fully paid for. All unpaid portion will be charged a penalty of 5% per month.', 40, finalY + 30);
            doc.text('Parties agree to submit to the jurisdiction of the court of the City of Manila in case of legal action arising from this transaction.', 40, finalY + 45);

            doc.text('Items Prepared & Checked by:                     No. of Boxes: __________               _________________________________                ____________', 40, finalY + 80);
            doc.text('_________________________                    No. of DRs:    __________                  Customer\'s Printed Name & Signature                          Date', 40, finalY + 95);
            doc.text('- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -', 40, finalY + 110);
            doc.text('DRM: For Company Use Only                        [  ] NO DISCREPANCY                      [  ] WITH DISCREPANCY                      [  ] BOX COUNT ONLY', 40, finalY + 130);

            finalY += 155;

            // new table for item details (fixed table)
            const newTableColumns = [
                { header: 'Item No.', dataKey: 'itemNo' },
                { header: 'Particulars', dataKey: 'particulars' },
                { header: 'Per DR', dataKey: 'perDR' },
                { header: 'Actual', dataKey: 'actual' },
                { header: 'Remarks', dataKey: 'remarks' },
            ];

            const newTableData = [
                { itemNo: '', particulars: '', perDR: '', actual: '', remarks: '' },
                { itemNo: '', particulars: '', perDR: '', actual: '', remarks: '' },
                { itemNo: '', particulars: '', perDR: '', actual: '', remarks: '' },
                { itemNo: '', particulars: '', perDR: '', actual: '', remarks: '' },
                { itemNo: '', particulars: '', perDR: '', actual: '', remarks: '' },
            ];

            if (finalY + 250 > pageHeight) {
                doc.addPage();
                finalY = 80;
                addFooter(doc, pageWidth, pageHeight);
                addHeader(doc, companyData, documentDetails, xLeftKey, xRightKey, pageWidth, 1, 1);
            }

            const pageCount = doc.internal.getNumberOfPages();
            for(var i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                doc.text('PAGE ' + i + '/' + pageCount, xRightKey, 30, { align: 'right' });
            }

            doc.autoTable({
                theme: 'grid',
                head: [newTableColumns.map(col => col.header)],
                body: newTableData.map(row => Object.values(row)),
                startY: finalY,
                styles: { fontSize: 8 },
                margin: { left: 30, right: 30 },
                headStyles: { fillColor: null, textColor: [0, 0, 0], halign: 'center' },
                bodyStyles: { halign: 'center' },
                columnStyles: {
                    0: { halign: 'left' }, // itemNo
                    1: { halign: 'left' }, // particulars
                    2: { halign: 'center' }, // perDR
                    3: { halign: 'center' }, // actual
                    4: { halign: 'center' }, // remarks
                },
            });

            finalY += 120;

            // add row with texts
            const additionalRowY = finalY + 30;
            doc.setFontStyle("bold");
            doc.setFontSize(8);
            doc.text('Prepared by:', 40, additionalRowY);
            doc.text('Verified by:', 150, additionalRowY);
            doc.text('Conforme:', 260, additionalRowY);
            doc.text('Verified by:', 370, additionalRowY);
            doc.text('Adjusted by:', 480, additionalRowY);

            // next row with names
            const nextRowY = additionalRowY + 20;
            doc.text('________________', 40, nextRowY);
            doc.text('___________________', 150, nextRowY);
            doc.text('________________', 260, nextRowY);
            doc.text('________________', 370, nextRowY);
            doc.text('________________', 480, nextRowY);

            // additional row titles
            doc.setFontStyle("normal");
            doc.setFontSize(8);
            doc.text('  Sales Consultant', 40, nextRowY + 15);
            doc.text(' Area Sales Supervisor', 150, nextRowY + 15);
            doc.text('       Warehouse', 260, nextRowY + 15);
            doc.text('            Audit', 370, nextRowY + 15);
            doc.text('  Inventory Control', 480, nextRowY + 15);

            //doc.save(`CAS-${handleNull(documentDetails.cas_no)}.pdf`);
            window.open(doc.output('bloburl'), '_blank');
            this.spinning = false;
        },
    },
};

export default printReltrx;
